<script>
  import Grafico from './grafico/Grafico.svelte';
  import GraficoV2 from './grafico/GraficoV2.svelte';
	import Torta from './grafico/Torta.svelte';
  import CardList from './card/CardList.svelte';
  import { dataNazionale } from './stores/data-nazionale.store.js';
	import { dataRegioniLatest } from './stores/data-regioni-latest.store.js';

  export let source = {
    url:
      'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-andamento-nazionale/dpc-covid19-ita-andamento-nazionale.csv',
    desc: 'pcm-dpc',
  };


	$: pointsTorta = $dataRegioniLatest.map(entry => { return {
			label : entry.denominazione_regione,
			value : entry.nuovi_positivi
		};
	});

  $: points = $dataNazionale.map((entry, i) => {
    return {
      x: new Date(entry.data).getTime(),
      y: [
        { key: 'casi', value: entry.totale_casi, color: 'white' },
        { key: 'guariti', value: entry.dimessi_guariti, color: 'SeaGreen' },
        { key: 'deceduti', value: entry.deceduti, color: 'DarkGray' },
        {
          key: 'terapia intensiva',
          value: entry.terapia_intensiva,
          color: 'DarkRed',
        },
        {
          key: 'ospedalizzati',
          value: entry.totale_ospedalizzati,
          color: 'red',
        },
        {
          key: 'isolamento',
          value: entry.isolamento_domiciliare,
          color: 'orange',
        }
      ],
    };
  });

  $: data = $dataNazionale
    .map((entry, _) => {
      console.log("key: " , Object.keys(entry));
      return Object.values(entry);
    })
    .map((entry) => {
      var d = new Date(entry[0]);
      const ye = new Intl.DateTimeFormat('en', { year: '2-digit' }).format(d);
      const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      entry[0] = `${da}-${mo}-${ye}`;
      return entry;
    });

  $: points2 = $dataNazionale.map((entry, i) => {
    return {
      x: new Date(entry.data).getTime(),
      y: [
        {
          key: 'casi',
          value:
            i > 0
              ? $dataNazionale[i].totale_casi -
                $dataNazionale[i - 1].totale_casi
              : 0,
          color: 'white',
        },
        {
          key: 'guariti',
          value:
            i > 0
              ? $dataNazionale[i].dimessi_guariti -
                $dataNazionale[i - 1].dimessi_guariti
              : 0,
          color: 'SeaGreen',
        },
        {
          key: 'deceduti',
          value:
            i > 0
              ? $dataNazionale[i].deceduti - $dataNazionale[i - 1].deceduti
              : 0,
          color: 'DarkGray',
        },
        {
          key: 'terapia intensiva',
          value:
            i > 0
              ? Math.max(
                  0,
                  $dataNazionale[i].terapia_intensiva -
                    $dataNazionale[i - 1].terapia_intensiva
                )
              : 0,
          color: 'DarkRed',
        },
        {
          key: 'ospedalizzati',
          value:
            i > 0
              ? Math.max(
                  0,
                  $dataNazionale[i].totale_ospedalizzati -
                    $dataNazionale[i - 1].totale_ospedalizzati
                )
              : 0,
          color: 'red',
        },
        {
          key: 'isolamento',
          value: 
            i > 0
              ? Math.max(
                  0,
                  $dataNazionale[i].isolamento_domiciliare -
                    $dataNazionale[i - 1].isolamento_domiciliare
                )
              : 0,
          color: 'orange',
        }
      ],
    };
  });


  $: points3 = $dataNazionale.map((entry, i) => {
    return {
      x: new Date(entry.data).getTime(),
      y: [
				{
					key: 'tamponi',
					value: i > 0
              ? Math.max(
                  0,
                  $dataNazionale[i].tamponi -
                    $dataNazionale[i - 1].tamponi
                )
              : 0,
          color: 'yellow',
				}
		  ],
    };
  });

  $: cardValue =
    points2.length > 0 || points3.length > 0 ? calcolaCard(points2, points3) : [];

	$: dataAggiornamento = points.length > 0 ? "Dati del giorno " + dtf.format(new Date(points[points.length - 1].x)) : "Recupero dati in corso ...";
  
	const dtf = new Intl.DateTimeFormat('it', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit'
  });

	function calcolaCard(points2, points3) {
	  const arry1Today = calcola(points2.flatMap((entry) => entry.y));
    const arry2Today = calcolaTamponi(points3.flatMap((entry) => entry.y));
    const arry1Yesterday = calcola(points2.flatMap((entry) => entry.y), 2);
    const arry2Yesterday = calcolaTamponi(points3.flatMap((entry) => entry.y), 2);
    const arry12Today = arry2Today.concat(arry1Today);
    const arry12Yesterday = arry2Yesterday.concat(arry1Yesterday);
    const perc = arry12Today[1].value/arry12Today[0].value * 100;
    const percYesterday = arry12Yesterday[1].value/arry12Yesterday[0].value * 100;

    arry12Today.push({
        label: "Rapporto casi/tamponi",
        value: perc.toFixed(2) + "%",
        percentage: (((perc - percYesterday)/percYesterday) * 100).toFixed(0),
        direction: perc - percYesterday,
        invert: false,
      });

    const percCard = arry12Today[7];
    arry12Today[7] = arry12Today[2];
    arry12Today[2] = percCard;
    arry12Today[0].invert = true;
    arry12Today[3].invert = false;
    arry12Today[6].invert = false;
    arry12Today[7].invert = true;

    return arry12Today;
	}

  function calcola(arr, days = 1) {
    let ieri = arr.slice(arr.length - (12 * days), arr.length - (6 * days));
    let oggi = arr.slice(arr.length - 6 * days, arr.length - (6 * days)  + 6);
    let result = [];
    for (let i = 0; i < 6; i++) {
      result.push({
        label: oggi[i].key,
        value: oggi[i].value,
        percentage: Math.round(
          ((oggi[i].value - ieri[i].value) / ieri[i].value) * 100
        ),
        direction: oggi[i].value - ieri[i].value,
        invert: i == 2 ? true : false,
      });
    }
    return result;
  }

	function calcolaTamponi(arr, days = 1) {
    let ieri = arr.slice(arr.length - (2 * days), arr.length - (1 * days));
    let oggi = arr.slice(arr.length - (1 * days), arr.length -  (days)  + 1);


    let result = [];
    for (let i = 0; i < 1; i++) {
      result.push({
        label: oggi[i].key,
        value: oggi[i].value,
        percentage: Math.round(
          ((oggi[i].value - ieri[i].value) / ieri[i].value) * 100
        ),
        direction: oggi[i].value - ieri[i].value,
        invert: true,
      });
    }
    return result;
  }
</script>

<div class="bg-gray-200 rounded-lg p-8">
	<h2 class="text-blue-600 font-bold text-lg">{dataAggiornamento}</h2>
	<CardList bind:cardArrayValue={cardValue} class="mb-5"/>
	<br/><br/><br/><br/><br/><br/>
	<Torta bind:points={pointsTorta} ></Torta>
	<br />
  <h2 class="text-blue-600 font-bold text-lg">Totale</h2>
  <Grafico bind:points bind:source />
	<br />
  <h2 class="text-blue-600 font-bold text-lg">Puntuale</h2>
  <Grafico bind:points={points2} bind:source />
	<br />
	<h2 class="text-blue-600 font-bold text-lg">Tamponi</h2>
  <Grafico bind:points={points3} bind:source />
</div>
